import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import OTPInput from "react-otp-input";
import ModalLoading from "../components/ModalLoading";
import Footer from "../components/Footer";
import ButtonRequire from "../components/Button/ButtonRequire";
import { requestAuthPost } from "../api/authInstance";
import { useAuth } from "../components/auth/authContext";
import withAuth from "../components/withAuth";
import { toastNotify } from "../utils/Utils";
import axios from "axios";
import InformationSheet from "../components/Sheet/InformationSheet";
import Container from "../components/Container/Container";

const ConfirmOTP = () => {
  const [otp, setOtp] = useState("");

  const [showModalLoading, setShowModalLoading] = useState(false);
  const [counter, setCounter] = useState(30);
  // navigate
  const navigate = useNavigate();
  // location
  const { state } = useLocation();
  const { email } = state ?? "";

  const { userData, loading, fetchAuthData } = useAuth();

  const [sheetDetail, setSheetDetail] = useState({
    title: "",
    detail: ``,
    open: false,
  });

  useEffect(() => {
    const timer =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);

  async function ConfirmOTP() {
    setShowModalLoading(true);

    await requestAuthPost("auth/validate-otp", { email, otp })
      .then(async (res) => {
        const userLogin = res.data.data;
        const userOutlet = _.first(userLogin?.userOutlet);

        if (!userOutlet) {
          toastNotify("User not found or not have outlet", "error");
          navigate("/signin");
          return;
        } else {
          axios
            .get(`${process.env.REACT_APP_BASE_AUTH_URL_API}auth/me`, {
              headers: { Authorization: `Bearer ${userLogin.tokenUser}` },
            })
            .then((res) => {
              const addOnUser = res.data.data;
              if (
                userOutlet?.status === "INITIAL" &&
                userOutlet?.userRole?.walletAdmin
              ) {
                navigate("/register", {
                  state: {
                    user: userLogin,
                    outlet: userOutlet,
                    addOnUser,
                    token: userLogin.tokenUser,
                  },
                  replace: true,
                });
              } else {
                localStorage.setItem("dompet_user", JSON.stringify(userLogin));
                localStorage.setItem(
                  "dompet_detail_outlet",
                  JSON.stringify({
                    ...userOutlet,
                    retailer: addOnUser.outlet.retailer,
                  }),
                );
                localStorage.setItem("token_user", userLogin.tokenUser);
                fetchAuthData();
                navigate("/", { replace: true });
              }
            });
        }
      })
      .catch(() => {
        setSheetDetail({
          title: "Invalid OTP",
          detail:
            "The code you entered is incorrect. Please double-check and try again. If you didn't receive the code, resend it. Need help? Contact our support team.",
          open: true,
        });
        setOtp("");
      })
      .finally(() => {
        setShowModalLoading(false);
      });
  }

  async function ResendOTP(e) {
    e.preventDefault();
    setShowModalLoading(true);
    // resend otp by email
    await requestAuthPost("auth/login", {
      identifier: email,
      application: "WALLET",
    })
      .then((res) => {
        setCounter(60);
        setSheetDetail({
          title: "OTP Resent Successfully",
          detail: `A new One-Time Password (OTP) has been sent to your registered email ${email}. Please check your messages and enter the new code below.`,
          open: true,
          icon: "success-otp",
        });
      })
      .catch((error) => {
        console.error(error);
      });
    setShowModalLoading(false);
  }

  useEffect(() => {
    if (otp.length === 4) {
      ConfirmOTP();
    }
  }, [otp]);

  return (
    <>
      <ModalLoading
        showModal={showModalLoading}
        setShowModal={setShowModalLoading}
      />
      <div className="relative space-y-10">
        <Header title="Email Vertification" />
        <Container>
          <div className="bg-white px-6 py-10">
            {/* Form */}
            <form className="space-y-4">
              <div className="space-y-4">
                <p className="text-center text-sm">
                  Please enter the One-Time Password (OTP) sent to your
                  registered email{" "}
                  <span className="font-medium text-[#4CA6F8]">{email}</span>
                </p>
                <OTPInput
                  value={otp}
                  onChange={setOtp}
                  numInputs={4}
                  inputType="tel"
                  containerStyle="otp flex justify-between max-w-[18rem] mx-auto"
                  renderInput={(props) => <input {...props} />}
                  inputStyle="form-input h-14 !w-16 text-center text-3xl font-bold text-gray-700"
                />
              </div>
              <div className="space-x-1 text-center text-sm">
                <span>Didn't receive the OTP? </span>
                {counter !== 0 ? (
                  <span>{`${counter}`}</span>
                ) : (
                  <button
                    className="font-medium text-[#4CA6F8]  disabled:text-gray-400"
                    disabled={counter === 0 ? false : true}
                    onClick={(e) => ResendOTP(e)}
                  >
                    Resend Code
                  </button>
                )}
              </div>
              <ButtonRequire
                title="Verify"
                functionOnClick={ConfirmOTP}
                isDisabled={otp.length !== 4}
              />
            </form>
          </div>
        </Container>
        <div className="fixed bottom-0 mx-auto w-full px-6 pb-4">
          <Footer color="gray-400" />
        </div>
      </div>
      {/* Information Sheet */}
      <InformationSheet
        sheetDetail={sheetDetail}
        setSheetDetail={setSheetDetail}
      />
    </>
  );
};

export default withAuth(ConfirmOTP, { protectedRoute: false });
